import React, { useEffect, useState } from "react";
import { useCounter } from "../../Helpers/useCounter";

import { Alerta } from "../Cabezote/alerta.component";
//import noimage from '../../assets/icons/elementosA.svg'
import noimage from "../../assets/icons/productoNoDisponible.svg";
import { useSelector } from "react-redux";

import * as constant from "../../global/const";
import { Redemption } from "../Checkout/Redencion/Redemption.page";

const CardProdutosCarritos = (props) => {
  const carritoRedux = useSelector((state) => state.carrito.carrito);
  const [mensaje, setMensaje] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [showModalRedemption, setShowModalRedemption] = useState(false);
  const [currentValue, setCurrentValue] = useState(undefined);
  //const [imagenUrl, setImagenUrl ] = useState(`${constant.URL_BASE_IMAGES}image/${props.producto.codigoSku}.png?${Math.random()}`);
  const imagenUrl = `${constant.URL_BASE_IMAGES}image/${props.producto.codigoSku}.jpg?${Math.random()}`;
  const producto = props.producto;

  const {
    counter,
    handleDeleteToCart,
    setCounter,
    handleSubmitAddValidate,
    handleSubmitSubtractValidate,
    handleInputChange,
    handleInputBlur
   } = useCounter(
    props.producto.cantidad,
    setMensaje,
    setShowMessage,
    setShowModalRedemption
  );
  let { history } = props;
  const handleClickAdd = () => {
    /* handleSubmitAdd();
    handleChangeToCard(props.producto);
    getTotalAmount(); */

    /*
    if(Number.isInteger(counter)){
        handleSubmitAdd();
        handleChangeToCard(producto);
      }else{
        handleSubmitAdd(0.5);
        handleChangeToCard(producto, 0.5);
      }
      */
      handleSubmitAddValidate(producto)
  };

  const handleClickDelete = () => {
    /* handleSubmitSubtract();
    subtractFromCart(props.producto);
    getTotalAmount(); */

    handleSubmitSubtractValidate(producto)
  };

  useEffect(() => {
    if (carritoRedux["-" + props.producto.codigoSku]) {
      setCounter(carritoRedux["-" + props.producto.codigoSku].cantidad);
    } else {
      setCounter(0);
    }
  }, [carritoRedux]);

  return (
    <div className="card">
      {showMessage && (
        <Alerta
          history={history}
          mensaje={mensaje}
          show={showMessage}
          setShow={setShowMessage}
          setShowModalRedemption={setShowModalRedemption}
          tipo={0}
        />
      )}
      {showModalRedemption && (
        <Redemption
          codigoSku={mensaje.split("-")[1]}
          setShowModalRedemption={setShowModalRedemption}
        />
      )}

      <i
        className="far fa-times-circle"
        style={{ cursor: "pointer" }}
        onClick={() => handleDeleteToCart(props.producto)}
      ></i>
      <div className="nombre">
        <img
          className="foto"
          src={imagenUrl}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noimage;
          }}
          alt="First slide"
        />
        <div className="cuerpo">
          <h2 className="titulo">{props.producto.nombre}</h2>
          <div className="precioProducto">
            <h4 className="ahora">
              {" "}
              {" $" +
                new Intl.NumberFormat("de-DE", {
                  numberingSystem: "latn",
                  style: "decimal",
                  currency: "COP",
                }).format(props.producto.precio)}
            </h4>
          </div>
        </div>
      </div>

      <div className="cantidadProducto">
        <div className="contadorProducto">
          <i
            style={{ cursor: "pointer" }}
            className="fa fa-plus-circle"
            aria-hidden="true"
            onClick={() => {
              handleClickAdd();
            }}
          ></i>
          {/* <p> {props.producto.cantidad}</p> */}


          <input
            className="digitacion"
            onFocus={(e) => e.target.select()}
            onBlur={(e) => handleInputBlur(e.target.value, producto, setCurrentValue)}
            /* value={counter} */
            onChange={(e) => handleInputChange(e.target.value, producto, setCurrentValue)}
            value={currentValue ?? counter}
          />

          <i
            style={{ cursor: "pointer" }}
            className="fa fa-minus-circle"
            aria-hidden="true"
            disabled={false}
            onClick={() => {
              handleClickDelete();
            }}
          ></i>
        </div>
      </div>
    </div>
  );
};

export default CardProdutosCarritos;
